import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { initiateTikTokConnection } from '@/lib/api'
import { useAuth } from '@/hooks/useAuth'
import ConnectPlatform from '@/components/ConnectPlatform'

const TikTokConnect = () => {
  const navigate = useNavigate()
  const [connecting, setConnecting] = useState(false)
  const stopConnecting = useCallback(() => setConnecting(false), [])
  const { athlete } = useAuth()

  const hasPendingTikTokAuth = !!athlete?.authTokenInfo?.some(
    (auth: any) => auth.platform === 'tiktok',
  )
  const hasConnectedTikTok = !!athlete?.socialAccounts?.some(
    (account: any) => account.platform === 'tiktok',
  )

  const handleConnect = async () => {
    // Authorized on TikTok but didn't finish picking the account: pick up where they left off
    if (hasPendingTikTokAuth && !hasConnectedTikTok) {
      navigate('/tiktok/auth-steps?resume=1')
      return
    }
    setConnecting(true)
    try {
      await initiateTikTokConnection()
    } catch (error) {
      console.error('Failed to initiate TikTok connection:', error)
      setConnecting(false)
    }
  }

  return (
    <ConnectPlatform
      slug="tiktok"
      name="TikTok"
      iconBg="#000000"
      shows="Brands see your real views and reach, so you get better offers."
      buttonLabel="Connect TikTok"
      onConnect={handleConnect}
      connecting={connecting}
      onReturn={stopConnecting}
    />
  )
}

export default TikTokConnect
